export default __webpack_public_path__ + "static/media/sc-mp-ico.84f95266.svg";